module.exports = __webpack_public_path__ + "img/alfie-w11.ee931fcd.jpeg";